import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import MagazinePage from "./pages/MagazinePage";
import BulkUploadPage from "./pages/BulkUploadPage";
import { Toaster } from "./components/ui/sonner";
import { initLeadTracker } from "./lib/leadTracker";

function App() {
  useEffect(() => {
    initLeadTracker();
  }, []);

  return (
    <div className="App font-body">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/magazine" element={<MagazinePage />} />
          <Route path="/leads/bulk-upload" element={<BulkUploadPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" />
    </div>
  );
}


export default App;
